// Lib 
import { mapState } from "vuex";

// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { RENT_TYPE, PACKAGE_TYPE } from "@/constant/rental";
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { PERIOD } from "@/constant/fixedRental";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

// Component 
import PackageInformation from "@/views/component/RentalService/PackageInformation";

// Function 
const queryString = require('query-string');

export default {

    extends: baseRentalService,

    components: {
        PackageInformation,
    },

    data() {

        return {
            rentType: RENT_TYPE,

            dataNote: [
                {
                    label: 'Some things to note when clone image',
                    children: [
                        {
                            label: '• All software and data in your image will be completely copied.',
                        },
                        {
                            label: '• The copy process will usually take 1-3 minutes for each copy depending on the size of your current image.',
                        },
                    ]
                },
            ],

            request: {
                packageId: null,
                rentType: RENT_TYPE.NO_FIXED,
            },

            packageTypeList: PACKAGE_TYPE,
            servicePackageList: [],
            packageId: null,


            packageType: PACKAGE_TYPE.MULTI2,
            packageListElement: [],
            packageTypeIndexMap: [],
            maxItemInRows: 2,
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    watch: {
        targetImage: function (newVal, oldVal) {
            if (newVal) {
                this.changePackageListView();
            }
        },
    },

    computed: {
        ...mapState({
            serverReport: state => state.common.serverReport,
        }),

        isEnabled1Card() {
            let package1Card = this.servicePackageList.filter(x => x.numberCard === 1).length;
            return package1Card > 0;
        },
        isEnabled2N4Card() {
            let package2_4Card = this.servicePackageList.filter(x => (x.numberCard === 2 || x.numberCard === 4)).length;
            return package2_4Card > 0;
        },
        isEnabled6Card() {
            let package6Card = this.servicePackageList.filter(x => (x.numberCard === 6 || x.numberCard === 8)).length;
            return package6Card > 0;
        },
        isShowGroupTab() {
            let countTab = (this.isEnabled1Card ? 1 : 0) + (this.isEnabled2N4Card ? 1 : 0) + (this.isEnabled6Card ? 1 : 0);
            return countTab > 1;
        },
        packageListElementShow() {
            let dataFilter = this.packageListElement.filter(x => x.data.length > 0);
            this.packageTypeIndexMap = dataFilter.map(x => x.packageType);
            return dataFilter;
        }
    },

    created() {
    },

    methods: {

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.CHANGE_SERVICE_PACKAGE);
        },
        //#endregion

        //#region Selection package
        selectionPackage(id) {
            this.packageListElement.forEach(x => {
                x.data.forEach(element => {
                    if (element.id === id) {
                        this.request.packageId = element.id;
                    }
                });
            });
        },
        //#endregion 

        //#region Carousel changed
        carouselChanged(value) {
            this.packageType = this.packageTypeIndexMap[value];
            setTimeout(() => {
                this.defaultSelectionPackage(value);
            }, 300);
        },
        //#endregion

        //#region Filter service package
        filterServicePackage(value) {
            let findIndexCarousel = this.packageListElementShow.findIndex(x => x.packageType === parseInt(value));
            this.$refs.carousel.setActiveItem(findIndexCarousel);
            setTimeout(() => {
                this.defaultSelectionPackage(parseInt(value));
            }, 300);
        },
        //#endregion

        //#region Calculate display price
        calculateDisplayPrice(element, period) {
            element.priceBeforeDecimal = element[this.pricePropertiesName[period]].toFixed(2).toString().split(".")[0];
            element.priceAfterDecimal = element[this.pricePropertiesName[period]].toFixed(2).toString().split(".")[1];

            if (element.priceHourOriginal !== null) {
                element.priceOriginalBeforeDecimal = element.priceHourOriginal.toFixed(2).toString().split(".")[0];
                element.priceOriginalAfterDecimal = element.priceHourOriginal.toFixed(2).toString().split(".")[1];
            }
        },
        //#endregion

        //#region Default selection package
        defaultSelectionPackage(packageType) {

            let packageListData = this.packageListElement.find(x => x.packageType === packageType).data;
            let packageIndexSelect = 0;
            if (packageType === PACKAGE_TYPE.SINGLE) {
                packageIndexSelect = 0;
            } else if (packageType === PACKAGE_TYPE.MULTI1) {
                packageIndexSelect = (packageListData.length - 1);
            } else {
                packageIndexSelect = (packageListData.length - 1);
            }

            this.request.packageId = packageListData[packageIndexSelect].id;
            this.packageType = packageType;
        },
        //#endregion

        //#region Change package list view
        changePackageListView() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            let data = {
                packageId: this.targetImage.packageId
            }
            setTimeout(() => {
                api.baseRequest(SETTINGS_RENTAL_API.CHANGE_SERVICE_PACKAGE_LIST_VIEW, null, `?${queryString.stringify(data)}`)
                    .then((res) => {
                        let responseData = res.data;
                        responseData.forEach(element => {
                            this.calculateDisplayPrice(element, PERIOD.HOUR);
                        });
                        this.servicePackageList = responseData;

                        if (responseData.filter(x => x.numberCard > 1).length > 0) {
                            this.packageListElement = [
                                { data: responseData.filter(x => x.numberCard === 1), packageType: PACKAGE_TYPE.SINGLE },
                                { data: responseData.filter(x => (x.numberCard === 2 || x.numberCard === 4)), packageType: PACKAGE_TYPE.MULTI1 },
                                { data: responseData.filter(x => (x.numberCard === 6 || x.numberCard === 8)), packageType: PACKAGE_TYPE.MULTI2 }
                            ];

                            let lengthItemList = [
                                responseData.filter(x => x.numberCard === 1).length,
                                responseData.filter(x => (x.numberCard === 2 || x.numberCard === 4)).length,
                                responseData.filter(x => (x.numberCard === 6 || x.numberCard === 8)).length
                            ];

                            this.maxItemInRows = Math.max(...lengthItemList);
                            if (lengthItemList[2] > 0) {
                                this.defaultSelectionPackage(PACKAGE_TYPE.MULTI2);
                            }
                            else {
                                if (lengthItemList[1] > 0) {
                                    this.defaultSelectionPackage(PACKAGE_TYPE.MULTI1);
                                }
                                else {
                                    if (lengthItemList[0] > 0) {
                                        this.defaultSelectionPackage(PACKAGE_TYPE.SINGLE);
                                    }
                                }
                            }
                        } else {
                            this.packageListElement = [
                                { data: responseData.filter(x => x.numberCard === 1), packageType: PACKAGE_TYPE.SINGLE },
                            ];
                            let itemsLength = responseData.filter(x => x.numberCard === 1).length;
                            this.maxItemInRows = itemsLength;
                            if (itemsLength > 0) {
                                this.defaultSelectionPackage(PACKAGE_TYPE.SINGLE);
                            }
                        }
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.servicePackageList);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Request failed ...")
                    });
            }, this.smoothTimeOut);
        },
        //#endregion

        //#region Change package
        change() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    packageId: this.request.packageId,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.CHANGE_SERVICE_PACKAGE, data)
                    .then(() => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess('Duplicating ... !', `Image <span style="color: #42A5F5;"> #${this.targetImage.id} (${this.targetImage.name})</span> is duplicating</span>`);
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Boot failed ...")
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}